<template>
    <section class="row flex-column" v-loading="loading">
        <div class="block block-rounded block-bordered">
            <div class="block-header">
                <h3 class="block-title">Utility Bills <small>Transactions</small></h3>
            </div>
            <div class="block-content border-top">
                <div class="row">
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-money-bill-wave-alt text-primary"></i>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-w300 mb-0">
                                        <small class="small">KES</small> <span class="font-size-h4">15,450</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Total Value
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-money-check-alt text-success"></i>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-w300 mb-0">
                                        <small class="small">KES</small> <span class="font-size-h4">14,150</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Completed
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        960
                                    </p>
                                    <p class="text-muted mb-0">
                                        Sales
                                    </p>
                                </div>
                                <div>
                                    <i class="fa fa-2x fa-chart-area text-danger"></i>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <p class="font-w300 mb-0">
                                        <small class="small">KES</small> <span class="font-size-h4">520</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Commission
                                    </p>
                                </div>
                                <div>
                                    <i class="fa fa-2x fa-box text-warning"></i>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row border-top">
                    <div class="col-12 mt-2">
                        <div class="float-right">
                            <div class="form-group">
                                <el-input
                                    size="small"
                                    @input="searchTransaction"
                                    placeholder="Type something"
                                    prefix-icon="el-icon-search"
                                    v-model="query">
                                    <el-button @click="searchTransaction" type="success" slot="append"
                                               icon="el-icon-search">Search
                                    </el-button>
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-content-full mr-1  ml-1">
                    <table class="table align-content-center table-striped border">
                        <thead>
                        <tr>
                            <th>Reference</th>
                            <th>Amount</th>
                            <th>Payment Item</th>
                            <th>Customer Account</th>
                            <th>Status</th>
                            <th>Transaction Date</th>
                            <th>..</th>
                        </tr>
                        </thead>
                        <tbody class="small font-w500">
                        <tr v-for="(transaction, index) in transactions.data" :key="index"
                            v-if="transactions.data.length > 0">
                            <td>{{transaction.reference}}</td>
                            <td><strong> Ksh. {{transaction.amount}}</strong></td>
                            <td>{{transaction.paymentItem}}</td>
                            <td>{{transaction.customerAccount}}</td>
                            <td><small class="font-w700">{{transaction.status.toString().toUpperCase()}}</small>
                            </td>
                            <td>{{transaction.createdAt}}</td>
                            <td>...</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="block-content-full" v-if="transactions.data.length > 0">
                    <div class="mr-4">
                        <eml-pagination :limit="1" align="right" :data="transactions"
                                        @pagination-change-page="getTransactions"></eml-pagination>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {APP_CONFIG} from "../../config";


    export default {
        name: "ListTransactions",
        data() {
            return {
                transactions: {
                    data: [],
                    meta: {}
                },
                summary: {},
                query: '',
                data: {},
                loading: true
            }
        },
        mounted() {
            this.getTransactions();
            this.getSummary();
        },
        methods: {
            getTransactions(page = 1) {
                axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/utilitybills/transactions`, {
                    params: {page, search: this.query}
                }).then(res => {
                    this.transactions = res.data;
                    this.loading = false;
                    //this.transactions.meta = res.data.meta.pagination;
                }).catch((e) => {
                    this.dispatch('error', e);
                });
            },

            searchTransaction() {
                const search = _.throttle((vm) => {
                    vm.getTransactions()
                }, 1000);
                search(this);
            },

            getSummary() {
                axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/utilitybills/summary`)
                    .then(res => {
                        this.summary = _.flattenDepth(res.data.data.map(item => {
                            let value = [];
                            let key = item.status.toString().toLowerCase();
                            value[key] = item.value;

                            return value;
                        }), 1)
                    });
                //this.loading = false;
                //this.transactions.meta = res.data.meta.pagination;
            }
        }
    }
</script>

<style scoped>
    .col-md-6 .block {
        margin-bottom: 0;
    }
</style>
